import auth from '_helpers/authHelper'

const LOGIN_URL = 'auth/login'

const api = () => {
  const options = (method, body) => ({
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${auth.accessToken}`,
    },
    body: JSON.stringify(body),
  })

  const verify = async (path) => {
    if (path === LOGIN_URL) {
      return Promise.resolve()
    }

    const response = await fetch('/api/auth/verify_token', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token: auth.accessToken }),
    })
    const result = await response.json()
    const { error, accessToken } = result
    error ? null : auth.setAccessToken(accessToken)
  }

  return {
    post: async (path, body) =>
      verify(path).then(async () => {
        const response = await fetch(`/api/${path}`, options('POST', body))
        return await response.json()
      }),
    get: async (path) =>
      verify(path).then(async () => {
        const response = await fetch(`/api/${path}`, options('GET'))
        return await response.json()
      }),
    patch: async (path, body) =>
      verify(path).then(async () => {
        const response = await fetch(`/api/${path}`, options('PATCH', body))
        return await response.json()
      }),
    delete: async (path) =>
      verify(path).then(async () => {
        const response = await fetch(`/api/${path}`, options('DELETE'))
        return await response.json()
      }),
  }
}

export default api
